__turbopack_context__.v({
  "action": "L3flsW_action",
  "balloon": "L3flsW_balloon",
  "body": "L3flsW_body",
  "dismiss": "L3flsW_dismiss",
  "dismissed": "L3flsW_dismissed",
  "icon": "L3flsW_icon",
  "message": "L3flsW_message",
  "suggestion-fade-in": "L3flsW_suggestion-fade-in",
  "suggestion-fade-out": "L3flsW_suggestion-fade-out",
  "suggestion-in": "L3flsW_suggestion-in",
  "suggestion-out": "L3flsW_suggestion-out",
  "title": "L3flsW_title",
});
